import { render, staticRenderFns } from "./IconPhoneCalling.vue?vue&type=template&id=15567a2a"
import script from "./IconPhoneCalling.vue?vue&type=script&lang=ts"
export * from "./IconPhoneCalling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports